import { Hidden } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useRouteMatch } from 'react-router-dom';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { GuidedProcessSupportBlock } from '../../../../../global/components/guided-process-support-block';
import { MainContent } from '../../../../../global/components/layout/main-content-container';
import { PageContainer } from '../../../../../global/components/layout/page-container';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { SideBarContent } from '../../../../../global/components/layout/sidebar-content';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { ArcRoutes } from '../../../constants/routes';
import { GuidedProcessSupportProps, InstitutionProps } from '../../../models/arc-epi-props';
import { InstitutionState } from '../institution-model';
import { ReportAccessState } from '../../report/models/report-models';
import { getReportAccess } from '../../../../../global/ducks/report-prc-api';
import { setReportAccessRight } from '../../report/report-slices';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { ApiEndpoint } from '../../../../../global/constants/api-endpoints';
import { DomoLink } from '../../../../../global/components/domo-report-link';


export function ReportsDiocesan() {

	const pageContent = useSelector<TcsmStates, InstitutionProps>(state => state.epiProps?.institutionSettingsState?.epiContent);
	const routeMatch = useRouteMatch();
	const gpsSettings = useSelector<TcsmStates, GuidedProcessSupportProps>(state => state.epiProps?.gpsSettingsState?.epiContent);

	const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);
	const reportAccessState = useSelector<TcsmStates, ReportAccessState>(state => state.reportAccessState);
	const dioceseAccess = reportAccessState?.accessRights?.available_diocese?.find(a => a.client_number === institutionState?.institutionClientNumber);
	const dioceseSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.DioceseRoot}`);
	const dispatch = useDispatch();

	useEffect(() => {
		if (!reportAccessState.accessRightsLoaded) {
			dispatch(getReportAccess((res) => dispatch(setReportAccessRight(res?.data))));
		}

	}, []);

	if (!institutionState?.institutionClientNumber) {
		return (
			<Redirect to=
				{
					{
						pathname: dioceseSelect,
						state: {
							actionLink: routeMatch.path,
						},
					}
				}
			/>);
	}

	if (!pageContent || !gpsSettings || !reportAccessState?.accessRightsLoaded) {
		return <LoadingCircle />;
	}

	function RenderContent() {
		return (
			<DividerSection removeDivider>

				{
					dioceseAccess?.reports_access?.clergy_compensation_report &&

					<DomoLink linkText={pageContent?.clergyReportDownloadText}
						domoLink={`${ApiEndpoint.domoUrl}report_name=IRClergyCompensationReport&parent_institution_client_number=${institutionState?.institutionClientNumber}`} />
				}
				{
					dioceseAccess?.reports_access?.lay_compensation_report &&

					<DomoLink linkText={pageContent?.layReportDownloadText}
						domoLink={`${ApiEndpoint.domoUrl}report_name=IRLayCompensationReport&parent_institution_client_number=${institutionState?.institutionClientNumber}`} />
				}
				{
					dioceseAccess?.reports_access?.arrears_reports &&

					<DomoLink linkText={pageContent?.arrearsReportDownloadText}
						domoLink={`${ApiEndpoint.domoUrl}report_name=IRCPGDioceseArrearsReport&parent_institution_client_number=${institutionState?.institutionClientNumber}`} />
				}
				{
					dioceseAccess?.reports_access?.imputed_income_reports &&

					<DomoLink linkText={pageContent?.imputedIncomeReportDownloadText}
						domoLink={`${ApiEndpoint.domoUrl}report_name=IRImputedIncomeReport&parent_institution_client_number=${institutionState?.institutionClientNumber}`} />
				}
				{
					dioceseAccess?.reports_access?.institutions_list &&

					<DomoLink linkText={pageContent?.institutionListDownloadText}
						domoLink={`${ApiEndpoint.domoUrl}report_name=IRInstitutionsList&parent_institution_client_number=${institutionState?.institutionClientNumber}`} />
				}
				{
					dioceseAccess?.reports_access?.ir_summary_pension_medial_enrollment &&
					<DomoLink domoLink={`${ApiEndpoint.domoUrl}report_name=IRSummary-PensionandMedicalEnrollment&parent_institution_client_number=${institutionState?.institutionClientNumber}`} linkText={pageContent?.irSummaryReportDownloadText} />
				}

			</DividerSection>
		);
	}

	return (
		<PageContainer>
			<MainContent>
				<PageHeader headerText={pageContent?.diocesanReportTitle} description={pageContent?.diocesanReportDescription} />
				<Hidden mdUp>
					<SideBarContent>
						<GuidedProcessSupportBlock title={gpsSettings?.diocesanReportsGpsTitle} contents={gpsSettings?.diocesanReportsGps} />
					</SideBarContent>
				</Hidden>
				<RenderContent />
			</MainContent>

			<Hidden smDown>
				<SideBarContent>
					<GuidedProcessSupportBlock title={gpsSettings?.diocesanReportsGpsTitle} contents={gpsSettings?.diocesanReportsGps} />
				</SideBarContent>
			</Hidden>
		</PageContainer>
	);
}

export default ReportsDiocesan;